/*! Dawn cart-drawer.js — neutralized; bliss-cart-drawer.js handles cart UI */
class CartItems extends HTMLElement { constructor() { super(); } }
if (!customElements.get('cart-items')) customElements.define('cart-items', CartItems);
class CartDrawer extends HTMLElement { constructor() { super(); } }
if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);
class CartDrawerItems extends CartItems {}
if (!customElements.get('cart-drawer-items')) customElements.define('cart-drawer-items', CartDrawerItems);
class CartRemoveButton extends HTMLElement { constructor() { super(); } }
if (!customElements.get('cart-remove-button')) customElements.define('cart-remove-button', CartRemoveButton);
window.CartItems = CartItems;
window.CartDrawer = CartDrawer;
window.CartDrawerItems = CartDrawerItems;
window.CartRemoveButton = CartRemoveButton;
